export default {
    mounted(el) {
      // التأكد من أن الكود يُنفذ فقط على جانب العميل
      if (typeof window !== 'undefined' && typeof document !== 'undefined') {
          
          if (window.bootstrap && window.bootstrap.Dropdown) {
            // تأكد من أن العنصر يحتوي على الصفة المناسبة
            new window.bootstrap.Dropdown(el);
        }

      }
    }
  };
  